import React, { useEffect, useMemo, useState } from "react";
import { Switch, Tooltip } from "antd";
import {
  enableBusinessAudioAlerts,
  getBusinessAudioSettings,
  saveBusinessAudioSettings,
  subscribeToBusinessAudioSettings,
} from "../utils/restaurantAudio";

type BusinessAudioAlertType =
  | "notification_unread"
  | "pos_cart_add"
  | "kitchen_new_order"
  | "production_confirmed";

interface BusinessAudioToggleProps {
  alertType: BusinessAudioAlertType;
  label: string;
  size?: "small" | "default";
}

const ALERT_CHANNELS: Record<BusinessAudioAlertType, string> = {
  notification_unread: "notifications",
  pos_cart_add: "pos",
  kitchen_new_order: "kitchen",
  production_confirmed: "production",
};

const BusinessAudioToggle: React.FC<BusinessAudioToggleProps> = ({
  alertType,
  label,
  size = "small",
}) => {
  const [settings, setSettings] = useState(getBusinessAudioSettings);
  const channel = ALERT_CHANNELS[alertType];

  const checked = useMemo(
    () => Boolean(settings.enabled && settings[channel]),
    [channel, settings]
  );

  useEffect(() => subscribeToBusinessAudioSettings(setSettings), []);

  const handleChange = async (enabled: boolean) => {
    if (enabled) {
      const nextSettings = await enableBusinessAudioAlerts({ [channel]: true });
      setSettings(nextSettings);
      return;
    }

    const nextSettings = saveBusinessAudioSettings({ [channel]: false });
    setSettings(nextSettings);
  };

  return (
    <Tooltip
      title={
        checked
          ? `${label} activees`
          : `${label} desactivees. Activez-les apres un clic utilisateur.`
      }
    >
      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        <Switch size={size} checked={checked} onChange={handleChange} />
        <span>{label}</span>
      </span>
    </Tooltip>
  );
};

export default BusinessAudioToggle;
